import { useEffect, useMemo } from 'react';

import { useMarketActions, useMarketState } from '@/entities/market/model/market.store';
import { SubscriptionStatus } from '@/entities/market/model/market.types';

import { isPlaydeckSubscriptionMarketItem } from '../helpers/is-playdeck-subscription-market-item';

export const usePDSubscription = () => {
  const { main } = useMarketState();
  const { fetchProducts } = useMarketActions();

  useEffect(() => {
    !main && void fetchProducts();
  }, [fetchProducts, main]);

  const PDSubscriptionMarketItem = useMemo(
    () => main?.find(isPlaydeckSubscriptionMarketItem),
    [main]
  );

  const status = PDSubscriptionMarketItem?.subscriptionDetails?.status;

  const isActivePDSubscription =
    status === SubscriptionStatus.Subscribed ||
    status === SubscriptionStatus.UnsubscribedButActive;

  return { isActivePDSubscription, PDSubscriptionMarketItem };
};
